import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CityOption } from "common/constants";
import React from "react";

export const PartnerSealImage: React.FC<PartnerSealImageProps> = ({ cityOption: { value, sealImageUrl } }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return <img src={sealImageUrl} style={{ height: isMobile ? 20 : 44 }} alt={`${value} Seal`} />;
};

export interface PartnerSealImageProps {
  cityOption: CityOption;
}

export default PartnerSealImage;
